<script>
import { RouterView } from 'vue-router'

export default {
  name: 'App',
  components: {
    RouterView
  }
}
</script>

<template>
  <component :is="$route.meta.layout || 'div'">
    <router-view />
  </component>
</template>

<style>
  @import "https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100..900;1,100..900&display=swap";
  @import "tailwindcss";
  @import "vue-multiselect/dist/vue-multiselect.min.css";

  html, body {
    font-family: 'Roboto', sans-serif;
  }

  textarea, textarea:hover, textarea:focus, textarea:active {
    border: none;
    outline: none;
  }

  input[disabled],select[disabled] {
    opacity:0.25;
  }

  div.multiselect {
    min-height: unset;
    margin-top: 2px;
  }

  div.multiselect--disabled {
    opacity:0.25;
  }

  div.multiselect__tags {
    background-color: theme('colors.neutral.100');
    padding-left: theme('padding.2');
    padding-right: theme('padding.2');
    border-radius: theme('radius.sm');
    border: theme('borderWidth.DEFAULT') solid theme('colors.gray.700');
    min-height: unset;
    padding-top: 5px;
  }

  input.multiselect__input {
    background-color: theme('colors.neutral.100');
  }

  span.multiselect__tag, span.multiselect__option--highlight, span.multiselect__option--highlight::after {
    background-color: theme('colors.gray.700');
    color: theme('colors.neutral.100');
  }

  span.multiselect__tag i.multiselect__tag-icon::after {
    color: theme('colors.neutral.100');
  }

  span.multiselect__single {
    background-color: theme('colors.neutral.100');
  }

  span.multiselect__option--selected.multiselect__option--highlight,
  span.multiselect__option--selected.multiselect__option--highlight::after {
    background-color: theme('colors.red.700');
  }

  span.multiselect__placeholder {
    margin-bottom: 6px;
  }

  span.multiselect__tag {
    margin-bottom: -1px;
  }

  div.multiselect__select {
    z-index: 9;
    top: 0;
    bottom: 0;
    height: unset;
  }

  span.multiselect__single {
    margin-top: 2px;
    margin-bottom: 7px;
  }

  div.vfm__overlay {
    background-color: rgba(0, 0, 0, 0.7);
  }

  @keyframes reduce-width {
    from {
      width: 100%;
    }

    to {
      width: 0;
    }
  }
</style>
